import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { useToast } from "../../context/toast/ToastContext";
import { LoadingButton } from "../../components/button/Button";
import { useAuthenticate } from "./network/resolver";
import { ENV_LISTS } from "../../core/EnvTranspiler";
import Input from "../../components/input/Input-v2";

export default function Login() {
  const toast = useToast();
  const { mutate: mutateLogin, isLoading: loadingLogin } = useAuthenticate();
  const [username, setUsername] = useState<string>(
    ENV_LISTS.MODE === "production" ? "" : "admin@email.com"
  );
  const [password, setPassword] = useState<string>(
    ENV_LISTS.MODE === "production" ? "" : "admin123"
  );

  function doLogin() {
    if (!username || !password) {
      toast.show("Mohon lengkapi field");
      return;
    }
    mutateLogin({
      password,
      email: username,
    });
  }

  return (
    <Box
      display={"flex"}
      justifyContent={"center"}
      height={"100vh"}
      alignItems={"center"}
    >
      <Box p={2} justifyContent={"center"} display={"flex"}>
        <Box>
          <img src="/login.svg" />
        </Box>
        <Box paddingLeft={10} paddingRight={10} alignContent={"center"}>
          <Typography fontWeight={"bold"} fontSize={29}>
            Welcome back
          </Typography>
          <Typography color={"rgba(0,0,0,0.5)"} fontSize={14}>
            Please enter your details
          </Typography>
          <Box marginTop={2}>
            <Input.Text
              label="Username"
              value={username}
              onChange={(e) => setUsername(e)}
            />
          </Box>
          <Box marginTop={1}>
            <Input.Text
              type="password"
              label="Password"
              value={password}
              onChange={(e) => setPassword(e)}
            />
          </Box>
          <Box marginTop={3}>
            <LoadingButton
              onClick={doLogin}
              isLoading={loadingLogin}
              text="Sign in"
              style={{ width: "100%" }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
